/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from 'react';
import { GetDeliveryTrackerAPI } from '../api/oms/common';
import { FeatureSwitches } from '../constants/feature-switches';
export var GetDeliveryTrackerInfo = function (request) {
    var _a = useState(undefined), deliveryTrackerData = _a[0], setDeliveryTrackerData = _a[1];
    var _b = useState(undefined), deliveryTrackerError = _b[0], setDeliveryTrackerError = _b[1];
    var _c = useState(false), deliveryTrackerLoaded = _c[0], setDeliveryTrackerLoaded = _c[1];
    useEffect(function () {
        if (request && (FeatureSwitches === null || FeatureSwitches === void 0 ? void 0 : FeatureSwitches.useTrackerAlignedUX)) {
            GetDeliveryTrackerAPI(request)
                .then(function (response) {
                var _a;
                response.data.traceId = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.traceid;
                setDeliveryTrackerData(response.data);
            })
                .catch(function (error) {
                setDeliveryTrackerError(error);
            })
                .finally(function () {
                setDeliveryTrackerLoaded(true);
            });
        }
        else {
            setDeliveryTrackerLoaded(true);
        }
    }, []);
    return [deliveryTrackerData, deliveryTrackerError, deliveryTrackerLoaded];
};
